<template>
  <div class="c-featured-text-row">
    <!-- eslint-disable vue/no-v-html -->
    <h2
      v-if="title"
      :class="titleClass"
      :style="{ fontFamily: titleFont }"
      v-html="title"
    />
    <!-- eslint-enable vue/no-v-html -->
    <h3
      v-if="subtitle"
      :class="subtitleClass"
      :style="{ fontFamily: subtitleFont }"
    >
      {{ subtitle }}
    </h3>
    <wysiwyg
      v-if="description"
      class="c-featured-text-row--description"
      :class="wysiwygClass"
      :paragraph-size="descriptionTypography"
      :html="description"
    />
  </div>
</template>

<script>
import Wysiwyg from '../wysiwyg/Wysiwyg'

export default {
  name: "FeaturedTextRow",
  components: {
    Wysiwyg
  },
  props: {
    textAlignment: {
      type: String,
      default: 'center',
    },
    mobileTextAlignment: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    titleFont: {
      type: String,
      default: 'Poppins'
    },
    titleMarginBottom: {
      type: String,
      default: 'x-small'
    },
    titleTypography: {
      type: String,
      default: 't-heading-7'
    },
    titleColor: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleTypography: {
      type: String,
      default: 't-heading-5'
    },
    subtitleMarginBottom: {
      type: String,
      default: 'xx-small'
    },
    subtitleFont: {
      type: String,
      default: 'Poppins'
    },
    subtitleColor: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: '',
    },
    descriptionFont: {
      type: String,
      default: 'Poppins'
    },
    descriptionTypography: {
      type: String,
      default: ''
    },
    descriptionMarginBottom: {
      type: String,
      default: ''
    },
    descriptionColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    titleClass() {
      let results = [this.titleTypography]
      if (this.subtitle || this.description) {
        results.push("u-margin-bottom-" + this.titleMarginBottom);
      }
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      return results;
    },
    subtitleClass() {
      let results = [this.subtitleTypography];
      if (this.description || this.cta) {
        results.push("u-margin-bottom-" + this.subtitleMarginBottom);
      }
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + '--' + this.subtitleColor);
      }
      return results;
    },
    wysiwygClass() {
      let wysiwygClass = [];
      if (this.descriptionMarginBottom.length > 0) {
        wysiwygClass.push("u-margin-bottom-" + this.descriptionMarginBottom);
      }
      if (this.descriptionColor) {
        wysiwygClass.push(this.titleTypography + '--' + this.descriptionColor);
      }
      else if (this.titleColor) {
        wysiwygClass.push(this.titleTypography + '--' + this.titleColor);
      }
      return wysiwygClass;
    },
  }
}
</script>

<style lang="scss" scoped>
.c-featured-text-row {
  &--description {
    padding: 0 20px;
    max-width: 80%;
    @include respond("phone"){
      max-width: 100%;
    }
  }
}
</style>
